import React, {
	useContext,
	useState,
	useEffect,
	useCallback,
	memo,
} from "react";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import "./Solicitacoes.css";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import TabelaRedux from "../../../contexts/Tabela";
import { getSolicitacao } from "../../../services/ModuloGerenciador/Solicitacao";
import RequestControllerRedux from "../../../contexts/RequestController";
import { motion } from "framer-motion";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import { aceitaSolicitacao } from "../../../services/ModuloGerenciador/Solicitacao";
import ModalPermissaoUsuario from "../../../components/ModalPermissaoUsuario/ModalPermissaoUsuario.tsx";
import { getUsuarioDependencias } from "../../../services/ModuloGerenciador/Geral.ts";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import { getUser } from "../../../services/ModuloGerenciador/Usuario.js";

function Solicitacoes() {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const { setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const [loading, setLoading] = useState(false);

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const [openToastErro, setOpenToastErro] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [openRegras, setOpenRegras] = useState(false);

	const [regras, setRegras] = useState([]);

	const [values, setValues] = useState({
		colunaSelecionada: null,
		usuarioId: null,
		regras: [],
	});

	const [semAutorizacao, setSemAutorizacao] = useState(false);
	const [listaUsuarios, setListaUsuario] = useState([]);
	const buscarUsuarios = useCallback(async () => {
		if (!profile?.token) return;
		setLoading(true);
		try {
			const result = await getUser(profile?.token);
			setListaUsuario(result.data);
		} catch (error) {
			setTextoErro(
				typeof error.response?.data === "string"
					? error.response?.data
					: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
			);
			setOpenToastErro(true);
		}
		setLoading(false);
	}, [profile?.token]);

	const handleCloseToastSucesso = useCallback(() => {
		setOpenToastSucesso(false);
	}, [openToastSucesso]);

	const handleCloseToastErro = useCallback(() => {
		setOpenToastErro(false);
	}, [openToastSucesso]);

	const buscarSolicitacoes = useCallback(async () => {
		setLoading(true);
		await getSolicitacao(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	}, [profile?.token, setTabelaRedux]);

	const formatList = useCallback((items) => {
		const categoriasConhecidas = {
			Viagens: [
				"Toledo",
				"Paranavai",
				"Gloria de Dourados",
				"Rio Verde",
				"Todos",
				"Frota",
				"Template Viagem",
				"Gloria de Dourados 2",
				"Gloria de Dourados 3",
				"T S Clientes",
				"Aguardando CTE",
				"Localizador Veículos",
				"Filiais",
				"Mesorregião",
			],
			Pedido: ["Pedido", "Gerenciamendo Pedido"],
			Diária: ["Estadia"],
			OnTime: ["On Time"],
			"Rotas e Rastreio": ["Rota", "Configurações de Rastreamento"],
			"Gestão de Pessoas": [
				"Clientes",
				"Motorista",
				"Grupo de Clientes",
				"Vincular Clientes",
				"Usuario",
			],
			"Gestão de Veículos": [
				"Veiculo",
				"Grupo Cargas",
				"Vincular Grupo Cargas",
				"Gerenciamento de Frota",
				"Gerenciamento de Frota Configurações",
				"Documentação",
			],
			"Dashboards e Configurações": [
				"Dashboard",
				"Estatísticas Terceiros",
				"Faturamento",
				"Configuracoes",
				"Permitir Alterar Frete Fiscal Viagem",
				"Painel",
				"Gerar Login",
				"Enviar Proposta",
				"Indicador Faturamento Mensal",
			],
			Geral: [
				"Uso Comum",
				"Avisos",
				"Cadastrar Cockpit",
				"Cadastrar Meta",
				"Precificação",
				"Cotação",
				"Alerta Geral",
				"Alerta Aprovação",
				"Configuração Diária",
				"Diárias",
			],
		};

		const categorias = {
			Viagens: [],
			Pedido: [],
			Diária: [],
			OnTime: [],
			"Rotas e Rastreio": [],
			"Gestão de Pessoas": [],
			"Gestão de Veículos": [],
			"Dashboards e Configurações": [],
			Geral: [],
			Outros: [],
		};

		items.forEach((item) => {
			let categoriaEncontrada = false;
			for (const [categoria, regras] of Object.entries(categoriasConhecidas)) {
				if (regras.includes(item.regra)) {
					categorias[categoria].push(item);
					categoriaEncontrada = true;
					break;
				}
			}
			if (!categoriaEncontrada) {
				categorias.Outros.push(item);
			}
		});

		return categorias;
	}, []);

	const buscarRegras = useCallback(async () => {
		setLoading(true);
		await getUsuarioDependencias(profile?.token)
			.then((result) => {
				const formattedList = formatList(result.data?.regras);
				const sortedList = Object.entries(formattedList)
					.sort((a, b) => b[1].length - a[1].length)
					.reduce((acc, [key, value]) => {
						acc[key] = value.map((regra) => ({
							...regra,
							check: false,
						}));
						return acc;
					}, {});
				setRegras(sortedList);
				setTabelaRedux({});
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	}, [profile?.token]);

	useEffect(() => {
		if (!profile?.usuario) return;
		setSemAutorizacao(!hasRegra("Usuario"));
	}, []);

	const handleCloseRegras = useCallback(() => {
		setOpenRegras(false);
	}, []);

	const aceitarSolicitacao = useCallback(async () => {
		setLoading(true);
		var arr = values.regras.filter((item) => item !== 0);
		const objetoSolicitacao = {
			usuarioId: values.usuarioId,
			regras: arr,
			colunas: values.colunas,
		};
		await aceitaSolicitacao(objetoSolicitacao, profile?.token)
			.then(() => {
				setLoading(false);
				handleCloseRegras();
				setDadosRequestControllerRedux("Solicitacao Aceita");
				setValues((current) => ({ ...current, regras: [0] }));
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	}, [
		values.regras,
		values.usuarioId,
		values.colunas,
		profile?.token,
		handleCloseRegras,
		setDadosRequestControllerRedux,
	]);

	useEffect(() => {
		buscarSolicitacoes();
		buscarRegras();
		buscarUsuarios();
	}, [buscarSolicitacoes, buscarRegras, buscarUsuarios]);

	useEffect(() => {
		if (dadosRequestControllerRedux === "Solicitacao Aceita") {
			buscarSolicitacoes();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Solicitação aceita com sucesso");
			setOpenToastSucesso(true);
		}
		if (dadosRequestControllerRedux === "Solicitacao Recusada") {
			buscarSolicitacoes();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Solicitação recusada com sucesso");
			setOpenToastSucesso(true);
		}
	}, [dadosRequestControllerRedux, buscarSolicitacoes]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	if (loading) {
		return <LoadingComponent />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div>
				<NavbarV3 title="Solicitações" selecionado="Solicitações" />
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					<div className="embarques">
						<TabelaV2
							classeSelecionado="usuarioId"
							nomeClasse1="outer-wrapper-rota"
							nomeClasse2="table-wrapper-v2"
							colunas={tabelaEmpresa.Solicitacoes}
							dados={dadosTabela}
							setOpenRegras={setOpenRegras}
							setValues={setValues}
						/>
					</div>
					<div>
						<ToastSucesso
							texto={textoSucesso}
							open={openToastSucesso}
							onClose={handleCloseToastSucesso}
						/>
						<ToastErro
							texto={textoErro}
							open={openToastErro}
							onClose={handleCloseToastErro}
						/>
						<ModalPermissaoUsuario
							open={openRegras}
							onClose={handleCloseRegras}
							regras={regras}
							values={values}
							setValues={setValues}
							aceitarSolicitacao={aceitarSolicitacao}
							listaUsuarios={listaUsuarios}
						/>
					</div>
				</motion.div>
			</div>
		</motion.div>
	);
}

export default memo(Solicitacoes);
